import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import Logo from '../../components/Logo';
import { useAuth } from '../../hooks/useAuth';

const TabLink: React.FC<{ to: string; label: string }> = ({ to, label }) => {
  const location = useLocation();
  const active = location.pathname.startsWith(to);
  return (
    <Link
      to={to}
      className={`flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium rounded-lg transition-all duration-200 ${
        active 
          ? 'bg-indigo-100 text-indigo-700 border-2 border-indigo-200 shadow-sm' 
          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 border-2 border-transparent hover:border-gray-200'
      }`}
    >
      {label}
    </Link>
  );
};

const SuperAdminLayout: React.FC = () => {
  const { logout, isLogoutLoading } = useAuth();
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Header */}
      <div className="bg-white shadow-lg border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <Logo size="md" showTagline={false} />
              </div>
              <div className="ml-4">
                <h1 className="text-xl font-bold text-gray-900">Panel de Super Administración</h1>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <button
                onClick={() => logout()}
                disabled={isLogoutLoading}
                className="px-3 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50"
                title="Cerrar sesión"
              >
                {isLogoutLoading ? 'Cerrando…' : 'Cerrar sesión'}
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden">
          {/* Navigation Tabs */}
          <div className="bg-gray-50 border-b border-gray-200">
            <nav className="flex flex-wrap gap-2 px-6 py-4">
              <TabLink to="/super-admin/empresas" label="Empresas" />
              <TabLink to="/super-admin/planes" label="Planes" />
              <TabLink to="/super-admin/suscripciones" label="Suscripciones" />
            </nav>
          </div>
          
          {/* Content Area */}
          <div className="p-6 lg:p-8">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLayout;
